import React, { useEffect, useState } from 'react';
import { IO_INDAS_DATA_MAPPING_BULK_UPLOAD, IO_INDAS_DATA_MAPPING_BULK_DOWNLOAD } from '../../api/endpoints';
import UploadCSVFilesTable from '../../components/UploadCSVFilesTable/UploadCSVFilesTable';
import MastersTabBar from '../../components/Common/MastersTabBar/MastersTabBar';

const IOindasMappingUploadFiles = () => {

    const defaultData = [
        { key: '1', title: 'Order Allocation Updation Data Mapping', fileName: 'io_indas_data_mapping.csv' },
     ];

    return (
        <div className="px-6 pt-3">
            <MastersTabBar activeId="orderAllocationUpdation" />
            <UploadCSVFilesTable defaultData={defaultData} uploadApi = {IO_INDAS_DATA_MAPPING_BULK_UPLOAD} downloadApi ={IO_INDAS_DATA_MAPPING_BULK_DOWNLOAD}/>
        </div>
    )
};

export default IOindasMappingUploadFiles;